/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CaptureLabelKind = {
    Length: 'length',
    Weight: 'weight',
    Catch: 'catch',
} as const;
export type CaptureLabelKind = typeof CaptureLabelKind[keyof typeof CaptureLabelKind];


export function instanceOfCaptureLabelKind(value: any): boolean {
    for (const key in CaptureLabelKind) {
        if (Object.prototype.hasOwnProperty.call(CaptureLabelKind, key)) {
            if (CaptureLabelKind[key as keyof typeof CaptureLabelKind] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CaptureLabelKindFromJSON(json: any): CaptureLabelKind {
    return CaptureLabelKindFromJSONTyped(json, false);
}

export function CaptureLabelKindFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaptureLabelKind {
    return json as CaptureLabelKind;
}

export function CaptureLabelKindToJSON(value?: CaptureLabelKind | null): any {
    return value as any;
}

export function CaptureLabelKindToJSONTyped(value: any, ignoreDiscriminator: boolean): CaptureLabelKind {
    return value as CaptureLabelKind;
}

